import { MapaService } from './../../../../services/mapa.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Autos } from './../../../../../../_entities/autos/Autos';
import { Component, Inject, OnInit } from '@angular/core';

@Component({
	selector: 'kt-semaforo-modal',
	templateUrl: './semaforo-modal.component.html',
	styleUrls: ['./semaforo-modal.component.scss']
})
export class SemaforoModalComponent implements OnInit {
	public vehiculosRegistros: Autos[];
	public titulo: string;
	public icono: string;
	public showFilterRow: boolean;
	public showHeaderFilter: boolean;
	public showNavigationButtons: boolean;
	public showPageSizeSelector: boolean;
	public datosReporte = [];
	public isDisabled: boolean = true;

	constructor(public dialogRef: MatDialogRef<SemaforoModalComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private mapaServicio: MapaService) {
		this.showFilterRow = true;
		this.showHeaderFilter = true;
	}

	ngOnInit() {
		this.titulo = this.data[0].titulo;
		this.vehiculosRegistros = this.data[0].datos;
		this.icono = this.data[0].icono;
		this.vehiculosRegistros.forEach(vehiculo => {
			if(vehiculo.placas === null || vehiculo.placas === ''){
				vehiculo.placas = 'Sin Placa'
			}
			this.datosReporte.push({
				'Vehículo': vehiculo.descripcion,
				'Placa': vehiculo.placas
			});
		});
		if(this.datosReporte.length > 0){
			this.isDisabled = false;
		}
	}

	ngOnDestroy(): void {
		//Called once, before the instance is destroyed.
		//Add 'implements OnDestroy' to the class.
		this.vehiculosRegistros = [];

	}

	public minimizarPopup() {
		this.dialogRef.addPanelClass('displayNone');
	}

	public maximizarPopup() {
		this.dialogRef.removePanelClass('displayNone');
	}

	public cerrarPopup() {
		this.dialogRef.close();
		this.vehiculosRegistros = [];
		this.mapaServicio.alertaPrincipal = [];
		this.mapaServicio.alertaSecundaria = [];
		this.mapaServicio.alertaBateria = [];
		this.mapaServicio.alertaGeocerca = [];
		this.mapaServicio.alertaEnergia = [];


	}

	ubicarVehiculo(data) {
		this.mapaServicio.verVehiculo(data);
		this.cerrarPopup();
	}

}
